import type { Appearance } from "@stripe/stripe-js";

export const orderingPaymentAppearance: Appearance = {
  theme: "stripe",
  variables: {
    colorPrimary: "#1e3a5f",
    colorBackground: "#ffffff",
    colorText: "#0f172a",
    colorTextSecondary: "#64748b",
    borderRadius: "14px",
    fontFamily: "Inter, system-ui, sans-serif",
  },
};
